import { render, staticRenderFns } from "./type-button.vue?vue&type=template&id=434f8619&scoped=true&"
import script from "./type-button.vue?vue&type=script&lang=js&"
export * from "./type-button.vue?vue&type=script&lang=js&"
import style0 from "./type-button.vue?vue&type=style&index=0&id=434f8619&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f8619",
  null
  
)

export default component.exports